<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "LandingBackground",
  setup() {},
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #111240; /* average color from the sky of the bg */
  background-image: url("/images/backgrounds/bg-dws.jpg");
  background-size: cover;
  background-position: left 0;
  background-repeat: no-repeat;
}
</style>
